(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("4jlPh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "make", function () { return $3239ddfd94877bb3$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $3239ddfd94877bb3$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $3239ddfd94877bb3$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $3sSBX = parcelRequire("3sSBX");

var $gFKzh = parcelRequire("gFKzh");

var $ePRCc = parcelRequire("ePRCc");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $37BLX = parcelRequire("37BLX");

var $lBn5n = parcelRequire("lBn5n");

var $gSZul = parcelRequire("gSZul");

var $dhngN = parcelRequire("dhngN");

var $8E2YL = parcelRequire("8E2YL");
function $3239ddfd94877bb3$var$LauncherApp(Props) {
    var configId = Props.configId;
    var onOpenLink = Props.onOpenLink;
    var attributes = Props.attributes;
    var embedType = Props.embedType;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    $hBcYV.useRouter(undefined);
    var match$1 = $8E2YL.use(undefined);
    var trackEvent = $gFKzh.use(embedType);
    var contextualRoot = $lBn5n.useContextualRoot(/* Open */ 2, embedType, window.location.pathname);
    var contextualL1s = $lBn5n.useContextualL1s(embedType, /* Open */ 2, window.location.pathname);
    var pageOnlyHasLauncher = $37BLX.countInlineElementsByNamespace(namespace) === 0 && $37BLX.countBottombarElementsByNamespace(namespace) === 0;
    var tmp = {
        config: match$1.config,
        embedType: embedType,
        children: /*#__PURE__*/ $g85JO.createElement($3sSBX.make, {
            categories: $i7mYY.keep(contextualL1s, function(category) {
                return category.visibleInMenuBar;
            }),
            centered: true,
            className: $ezf3v.prefix("bg-main text-secondary py-4"),
            onTrackClick: function onTrackClick(param) {
                $iv6Yc.app(trackEvent, [
                    "open",
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                ]);
            },
            theme: /* Main */ 0
        })
    };
    if (attributes !== undefined) tmp.attributes = $loT9g.valFromOption(attributes);
    if (contextualRoot !== undefined) tmp.contextualRoot = $loT9g.valFromOption(contextualRoot);
    var tmp$1;
    if (pageOnlyHasLauncher) {
        var tmp$2 = {
            configId: configId,
            embedType: embedType,
            enabled: false
        };
        if (onOpenLink !== undefined) tmp$2.onOpenLink = $loT9g.valFromOption(onOpenLink);
        if (attributes !== undefined) tmp$2.attributes = $loT9g.valFromOption(attributes);
        tmp$1 = /*#__PURE__*/ $g85JO.createElement($gSZul.make, tmp$2);
    } else tmp$1 = null;
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "launcher",
        portal: false,
        children: /*#__PURE__*/ $g85JO.createElement($dhngN.make, tmp)
    }), tmp$1);
}
$3239ddfd94877bb3$var$LauncherApp.displayName = "LauncherApp";
var $3239ddfd94877bb3$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($3239ddfd94877bb3$var$LauncherApp);
var $3239ddfd94877bb3$export$aa541d093b11ace2 = $3239ddfd94877bb3$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("3sSBX", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $285e594aca7fdb2f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $dzlIC = parcelRequire("dzlIC");

var $5tfgg = parcelRequire("5tfgg");

var $hBcYV = parcelRequire("hBcYV");

var $eIwLU = parcelRequire("eIwLU");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");
function $285e594aca7fdb2f$var$Launcher(Props) {
    var style = Props.style;
    var isNestedOpt = Props.isNested;
    var highlightedCategoryId = Props.highlightedCategoryId;
    var categories = Props.categories;
    var forceStyle = Props.forceStyle;
    var centeredOpt = Props.centered;
    var paddedOpt = Props.padded;
    var classNameOpt = Props.className;
    var dataTestId = Props.dataTestId;
    var sliderDataTestId = Props.sliderDataTestId;
    var sliderInsetMargin = Props.sliderInsetMargin;
    var slidesPerView = Props.slidesPerView;
    var onItemMouseEnter = Props.onItemMouseEnter;
    var onItemClick = Props.onItemClick;
    var onTrackClick = Props.onTrackClick;
    var onItemRendered = Props.onItemRendered;
    var ariaLabel = Props.ariaLabel;
    var tabIndex = Props.tabIndex;
    var theme = Props.theme;
    var isNested = isNestedOpt !== undefined ? isNestedOpt : false;
    var centered = centeredOpt !== undefined ? centeredOpt : false;
    var padded = paddedOpt !== undefined ? paddedOpt : true;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var match = $hBcYV.useRouter(undefined);
    var listPageType = match.listPageType;
    var goTo = match.goTo;
    var match$1 = $9pMGg.use(undefined);
    var onClick = match$1.onLauncherItemClick;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, categories);
    var match$2 = $8E2YL.use(undefined).config;
    var settings = match$2.settings;
    $g85JO.useEffect(function() {
        var isAnyQuickViewStories = $i7mYY.some(categories, $1xf0g.isQuickViewStoriesEnabled);
        if (isAnyQuickViewStories && !isNested) $iv6Yc._1($b8WNX.preload, undefined);
    }, [
        categories
    ]);
    var match$3 = settings.mkrBio;
    var border = match$3 !== undefined && !isNested ? /* BorderBottom */ 1 : /* BorderNone */ 0;
    var match$4 = settings.mkrBio;
    var indicatorThickness = match$4 !== undefined ? /* Sm */ 1 : /* Normal */ 0;
    var match$5 = settings.mkrBio;
    var height = match$5 !== undefined ? /* Lg */ 1 : /* Normal */ 0;
    var activeCategoryPath = $i7mYY.map($2whNH.mapWithDefault($2whNH.map(activeCategory, function(category) {
        return category.id;
    }), [], function(id) {
        return $1xf0g.getCategoryPathById(categories, id);
    }), function(category) {
        return category.id;
    });
    var activeCategoryId = $2whNH.map($i7mYY.getBy(categories, function(category) {
        return activeCategoryPath.includes(category.id);
    }), function(category) {
        return category.id;
    });
    var match$6 = settings.indexNode;
    var activeCategoryId$1 = activeCategoryId !== undefined ? activeCategoryId : match$6 !== undefined && match$6.visibleInMenuBar && match.route !== /* NotRendered */ 0 && !isNested ? match$6.id : undefined;
    var activeCategoryId$2 = $2whNH.keep(activeCategoryId$1, function(param) {
        if ($7bjme.notequal(listPageType, /* History */ 1)) return $7bjme.notequal(listPageType, /* Favorites */ 0);
        else return false;
    });
    var layout = forceStyle !== undefined ? forceStyle : isNested ? settings.nestedCategoryLayout : settings.categoryLayout;
    var size = isNested ? settings.nestedCategorySize : settings.categorySize;
    var onClick$1 = $g85JO.useCallback($iv6Yc.__1(onClick), [
        onClick
    ]);
    var onClick$2 = $2whNH.getWithDefault(onItemClick, onClick$1);
    var onMouseEnter = $2whNH.getWithDefault(onItemMouseEnter, function(param) {});
    var partial_arg = false;
    var items = $i7mYY.map(categories, function(param) {
        return $5tfgg.fromCategory(partial_arg, param);
    });
    var match$7 = settings.mkrBio;
    var match$8 = items.length;
    var items$1 = match$7 !== undefined && match$8 === 1 ? [] : items;
    var onChange = function onChange(id) {
        var category = $i7mYY.getBy(categories, function(category) {
            return category.id === id;
        });
        if (category === undefined) return;
        $2whNH.forEach(onTrackClick, function(onTrackClick) {
            $iv6Yc._1(onTrackClick, category);
        });
        var match = $1xf0g.Link.getCardLink(category);
        if (match === undefined) return $iv6Yc._1(onClick$2, category);
        switch(match.TAG | 0){
            case /* URL */ 0:
                return;
            case /* Category */ 1:
                var match$1 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* Category */ 0,
                            _0: match$1.categoryId
                        },
                        viewPLP: false,
                        filters: match$1.filters,
                        sort: undefined
                    }
                });
            case /* Product */ 2:
                var match$2 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: undefined,
                        productCategoryId: match$2.productCategoryId,
                        productId: match$2.productId,
                        variantId: match$2.variantId,
                        zoomedPhotoIndex: undefined
                    }
                });
            case /* StoreCategory */ 3:
                var match$3 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* StoreCategory */ 2,
                            _0: {
                                categoryId: match$3.categoryId,
                                sourceNodeId: category.id
                            }
                        },
                        viewPLP: false,
                        filters: undefined,
                        sort: match$3.sortBy
                    }
                });
            case /* CustomAction */ 4:
                var match$4 = match._0;
                $dzlIC.triggerCustomFunctionWithoutProducts(match$4.code, match$4.name, undefined, undefined);
                return;
        }
    };
    var onHover = function onHover(id) {
        var category = $i7mYY.getBy(categories, function(category) {
            return category.id === id;
        });
        if (category !== undefined) return $iv6Yc._1(onMouseEnter, category);
    };
    if ($7bjme.equal(items$1, [])) return null;
    var tmp = {
        items: items$1,
        layout: layout,
        size: size,
        theme: theme,
        centered: centered,
        verticallyCenter: layout === /* Labels */ 0,
        className: className,
        onChange: onChange,
        onHover: onHover,
        border: border,
        indicatorThickness: indicatorThickness,
        height: height
    };
    if (highlightedCategoryId !== undefined) tmp.highlightValue = $loT9g.valFromOption(highlightedCategoryId);
    if (activeCategoryId$2 !== undefined) tmp.activeValue = $loT9g.valFromOption(activeCategoryId$2);
    if (dataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(dataTestId);
    if (sliderDataTestId !== undefined) tmp.sliderDataTestId = $loT9g.valFromOption(sliderDataTestId);
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    var tmp$1 = padded ? undefined : 0;
    if (tmp$1 !== undefined) tmp.padding = tmp$1;
    if (onItemRendered !== undefined) tmp.onItemRendered = $loT9g.valFromOption(onItemRendered);
    var tmp$2 = padded ? undefined : /* Zero */ 3;
    if (tmp$2 !== undefined) tmp.gap = $loT9g.valFromOption(tmp$2);
    if (slidesPerView !== undefined) tmp.slidesPerView = slidesPerView;
    if (sliderInsetMargin !== undefined) tmp.sliderInsetMargin = $loT9g.valFromOption(sliderInsetMargin);
    if (ariaLabel !== undefined) tmp.ariaLabel = $loT9g.valFromOption(ariaLabel);
    if (tabIndex !== undefined) tmp.tabIndex = $loT9g.valFromOption(tabIndex);
    return /*#__PURE__*/ $g85JO.createElement($eIwLU.make, tmp);
}
$285e594aca7fdb2f$var$Launcher.displayName = "Launcher";
var $285e594aca7fdb2f$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($285e594aca7fdb2f$var$Launcher);
var $285e594aca7fdb2f$export$aa541d093b11ace2 = $285e594aca7fdb2f$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("b8WNX", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $81ce0e7d77235b59$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $81ce0e7d77235b59$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $81ce0e7d77235b59$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("lSt1Q"));
});
function $81ce0e7d77235b59$var$QuickViewOverlay_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($81ce0e7d77235b59$var$component, Props);
}
$81ce0e7d77235b59$var$QuickViewOverlay_Lazy.displayName = "QuickViewOverlay_Lazy";
var $81ce0e7d77235b59$export$513ccb98c53b8039 = $81ce0e7d77235b59$var$component.preload;
var $81ce0e7d77235b59$export$dd44f18ab656f3bb = $81ce0e7d77235b59$var$QuickViewOverlay_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("lSt1Q", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("cYw4f")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5PtUs")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("3pqCl"))
]).then(function() {
    return parcelRequire("1xMeg");
});

});



parcelRegister("37BLX", function(module, exports) {

$parcel$export(module.exports, "countInlineElementsByNamespace", function () { return $245f535c80fa97b7$export$7460c80d7c5cf75c; });
$parcel$export(module.exports, "countBottombarElementsByNamespace", function () { return $245f535c80fa97b7$export$3a44f3abf1840775; });
$parcel$export(module.exports, "countLauncherElementsByNamespace", function () { return $245f535c80fa97b7$export$ac754b9504a93a08; });
$parcel$export(module.exports, "countSectionElementsByNamespace", function () { return $245f535c80fa97b7$export$b75c7a415a35e365; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $h6rW7 = parcelRequire("h6rW7");
function $245f535c80fa97b7$export$36d3479b5d03ac38(el) {
    var namespace = el.getAttribute("data-namespace");
    if (namespace == null) return $h6rW7.empty;
    else return $h6rW7.fromString(namespace);
}
function $245f535c80fa97b7$export$d0ebfc305a7a6844(elements, namespace) {
    var namespace$1 = $2whNH.getWithDefault(namespace, $h6rW7.empty);
    return $i7mYY.keep($2whNH.getWithDefault($2whNH.map(elements, $d3YYW.values), []), function(element) {
        return $7bjme.equal($245f535c80fa97b7$export$36d3479b5d03ac38(element), namespace$1);
    });
}
function $245f535c80fa97b7$export$a82d8d7911f406ff(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace);
}
function $245f535c80fa97b7$export$310f9fbcf0732046(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace);
}
function $245f535c80fa97b7$export$677c1fd84b0cad4f(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace);
}
function $245f535c80fa97b7$export$bbd7846266bc9fe8(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace);
}
function $245f535c80fa97b7$export$58368f7b4fc9b76d(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace);
}
function $245f535c80fa97b7$export$7460c80d7c5cf75c(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace).length;
}
function $245f535c80fa97b7$export$3a44f3abf1840775(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace).length;
}
function $245f535c80fa97b7$export$ac754b9504a93a08(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace).length;
}
function $245f535c80fa97b7$export$b75c7a415a35e365(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace).length;
}
function $245f535c80fa97b7$export$65ea36736e2b48c7(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace).length;
}
 /* No side effect */ 
});

parcelRegister("lBn5n", function(module, exports) {

$parcel$export(module.exports, "useContextualRoot", function () { return $fb9ef608eb76e9b2$export$fd42e504a4d8f825; });
$parcel$export(module.exports, "useContextualL1s", function () { return $fb9ef608eb76e9b2$export$f20aa461418ac738; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $bygWp = parcelRequire("bygWp");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $fb9ef608eb76e9b2$export$b829272b1dcc6798(url) {
    try {
        return $2whNH.map($2whNH.map($bygWp.maybeMakeUrl(url), function(prim) {
            return prim.pathname;
        }), function(prim) {
            return prim.toLowerCase();
        });
    } catch (exn) {
        return;
    }
}
function $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories) {
    if (urlPathname === "/") return;
    var l1Match = topLevelCategories.find(function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var link = $1xf0g.getCategoryLink(cat);
        if (link !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(link));
        else return false;
    });
    var l1Match$1 = l1Match === undefined ? undefined : $loT9g.some(l1Match);
    var l2OrDeeperMatch = $1xf0g.findCategoryBy(topLevelCategories, function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var match = $1xf0g.getCategoryLink(cat);
        if (l1Match !== undefined) {
            if (match !== undefined && $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match))) return l1Match.id !== cat.id;
            else return false;
        } else if (match !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match));
        else return false;
    });
    if (l2OrDeeperMatch !== undefined) return l2OrDeeperMatch;
    else return l1Match$1;
}
function $fb9ef608eb76e9b2$export$7f3d9773c89e0196(topLevelCategories, category) {
    return $1xf0g.getCategoryParentById(topLevelCategories, category.id);
}
function $fb9ef608eb76e9b2$export$2b5083f21a7660c3(categories, fallback) {
    if ($i7mYY.keep(categories, function(category) {
        return category.visibleInMenuBar;
    }).length === 0) return fallback;
    else return categories;
}
function $fb9ef608eb76e9b2$export$fd42e504a4d8f825(drawerState, embedType, urlPathname) {
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var canUseContextualL1s = embedType !== /* Inline */ 1 && settings.contextualL1s && drawerState !== /* Open */ 2 || settings.contextualInline && embedType === /* Inline */ 1;
    if (canUseContextualL1s) return $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, match.categories);
}
function $fb9ef608eb76e9b2$export$f20aa461418ac738(embedType, drawerState, urlPathname) {
    var hasNavigatedAwayFromContextualRoot = $g85JO.useRef(false);
    var match = $8E2YL.use(undefined).config;
    var topLevelCategories = match.categories;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, topLevelCategories);
    var canUseContextualL1s = (embedType === /* Bottombar */ 0 || embedType === /* Launcher */ 2) && match.settings.contextualL1s && drawerState !== /* Open */ 2;
    if (!canUseContextualL1s) return topLevelCategories;
    var contextualRoot = $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories);
    var isInRootsOrParentPath;
    if (contextualRoot !== undefined) {
        var isRootPLP = $1xf0g.isPLP(contextualRoot);
        var inRootsPath = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
            return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
        }).some(function(cat) {
            return cat.id === contextualRoot.id;
        });
        if (inRootsPath) isInRootsOrParentPath = true;
        else {
            var tmp = false;
            if (isRootPLP) {
                var rootParent = $1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id);
                tmp = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
                    return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
                }).some(function(cat) {
                    return cat.id === $2whNH.mapWithDefault(rootParent, "", function(parent) {
                        return parent.id;
                    });
                });
            }
            isInRootsOrParentPath = tmp;
        }
    } else isInRootsOrParentPath = false;
    if (!isInRootsOrParentPath && drawerState === /* Open */ 2) hasNavigatedAwayFromContextualRoot.current = true;
    if (drawerState === /* Closed */ 0) hasNavigatedAwayFromContextualRoot.current = false;
    var canUseContextualL1s$1 = canUseContextualL1s && (drawerState === /* Closed */ 0 || isInRootsOrParentPath) && (drawerState === /* Closed */ 0 || !hasNavigatedAwayFromContextualRoot.current);
    if (contextualRoot === undefined) return topLevelCategories;
    if (!canUseContextualL1s$1) return topLevelCategories;
    var match$1 = contextualRoot.listPageActiveLayout;
    var isPLP;
    isPLP = typeof match$1 === "number" || match$1.TAG !== /* ProductGrid */ 3 ? false : true;
    if (isPLP) return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($2whNH.mapWithDefault($1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id), topLevelCategories, $1xf0g.getChildren), topLevelCategories);
    else return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($1xf0g.getChildren(contextualRoot), topLevelCategories);
}
 /* react Not a pure module */ 
});

parcelRegister("gSZul", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $c4b162cf14bff716$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $c4b162cf14bff716$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("eai7O"));
});
function $c4b162cf14bff716$var$BottombarApp_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($c4b162cf14bff716$var$component, Props);
}
$c4b162cf14bff716$var$BottombarApp_Lazy.displayName = "BottombarApp_Lazy";
var $c4b162cf14bff716$export$dd44f18ab656f3bb = $c4b162cf14bff716$var$BottombarApp_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("eai7O", function(module, exports) {






















module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("95FGc")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9j6sg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("cYw4f")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("b6X9u")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1CMBB")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fRua9")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hBqlq"))
]).then(function() {
    return parcelRequire("hjWPk");
});

});



parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});

parcelRegister("2Mb3w", function(module, exports) {

$parcel$export(module.exports, "getBrowser", function () { return $2058a3ec51237c4b$export$89e15fc796a4a429; });
$parcel$export(module.exports, "isSafariVersion__16_3", function () { return $2058a3ec51237c4b$export$91773661b17fb447; });
$parcel$export(module.exports, "getOS", function () { return $2058a3ec51237c4b$export$34ee789f81ad4cb9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");
var $2058a3ec51237c4b$export$60cc2146340a7149 = function getAppVersion() {
    return navigator.appVersion;
};
var $2058a3ec51237c4b$export$7935961ef7719cb0 = function getUserAgent() {
    return navigator.userAgent;
};
function $2058a3ec51237c4b$export$89e15fc796a4a429(param) {
    var userAgentString = $iv6Yc._1($2058a3ec51237c4b$export$7935961ef7719cb0, undefined);
    var chromeAgent = userAgentString.indexOf("Chrome") > -1;
    var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
    var safariAgent = userAgentString.indexOf("Safari") > -1;
    if (chromeAgent) return /* Chrome */ 0;
    else if (firefoxAgent) return /* Firefox */ 2;
    else if (safariAgent) return /* Safari */ 1;
    else return /* UnknownBrowser */ 3;
}
function $2058a3ec51237c4b$export$91773661b17fb447(param) {
    var userAgentString = $iv6Yc._1($2058a3ec51237c4b$export$7935961ef7719cb0, undefined);
    var match = $2058a3ec51237c4b$export$89e15fc796a4a429(undefined);
    if (match !== 1) return false;
    else return userAgentString.includes("iPhone OS 16_3");
}
function $2058a3ec51237c4b$export$34ee789f81ad4cb9(param) {
    var appVersion = $iv6Yc._1($2058a3ec51237c4b$export$60cc2146340a7149, undefined);
    if (appVersion.includes("Win")) return /* Windows */ 1;
    else if (appVersion.includes("iPhone OS")) return /* IOS */ 3;
    else if (appVersion.includes("Mac")) return /* Mac */ 0;
    else if (appVersion.includes("Linux")) return /* Linux */ 2;
    else return /* UnknownOs */ 4;
}
 /* No side effect */ 
});

parcelRegister("2XXXw", function(module, exports) {

$parcel$export(module.exports, "ScrollRestorationLocalStorage", function () { return $228f9a1798c51d97$export$791f6fca0d60efd9; });
$parcel$export(module.exports, "setBreakingPoint", function () { return $228f9a1798c51d97$export$1dfa5e58b4233c3; });
$parcel$export(module.exports, "removeBreakingPoint", function () { return $228f9a1798c51d97$export$16e7fafba7e176d; });
$parcel$export(module.exports, "setCurrentScroll", function () { return $228f9a1798c51d97$export$6e32c7a2bca8fb40; });
$parcel$export(module.exports, "getClosestBreakingPoint", function () { return $228f9a1798c51d97$export$69a851a551f434f5; });
$parcel$export(module.exports, "setScrollLock", function () { return $228f9a1798c51d97$export$a2324b57a6a5ec84; });
$parcel$export(module.exports, "clearScrollLock", function () { return $228f9a1798c51d97$export$14e0addec6650b88; });
$parcel$export(module.exports, "getScroll", function () { return $228f9a1798c51d97$export$ff41c598de81c14a; });
$parcel$export(module.exports, "isBlockingOnScrollEvent", function () { return $228f9a1798c51d97$export$51e57029e6716073; });
$parcel$export(module.exports, "useScrollRestoration", function () { return $228f9a1798c51d97$export$c4ffdfe23dd48040; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $79vie = parcelRequire("79vie");

var $58Tj9 = parcelRequire("58Tj9");

var $jVmMx = parcelRequire("jVmMx");

var $kJhYp = parcelRequire("kJhYp");

var $gO2mJ = parcelRequire("gO2mJ");

var $8wpG4 = parcelRequire("8wpG4");

var $efwy1 = parcelRequire("efwy1");

var $25dxq = parcelRequire("25dxq");
$gO2mJ.setScrollRestoration("manual");
function $228f9a1798c51d97$export$a91724a679733655(position) {
    if (typeof position === "number") return $iv6Yc._2($jVmMx.Encode.array, [
        "Zero"
    ], $jVmMx.Encode.string);
    else if (position.TAG === /* Pixels */ 0) return $jVmMx.Encode.deccoVariantWithPayload(position._0, "Pixels", $jVmMx.Encode.$$int);
    else return $jVmMx.Encode.deccoVariantWithPayload(position._0, "Index", $jVmMx.Encode.$$int);
}
var $228f9a1798c51d97$var$zero = $79vie.map($79vie.index(0, $jVmMx.Decode.exactString("Zero")), function(param) {
    return /* Zero */ 0;
});
var $228f9a1798c51d97$var$pixels = $jVmMx.Decode.deccoVariantWithPayload("Pixels", $79vie.$$int, function(v) {
    return {
        TAG: /* Pixels */ 0,
        _0: v
    };
});
var $228f9a1798c51d97$var$index = $jVmMx.Decode.deccoVariantWithPayload("Index", $79vie.$$int, function(v) {
    return {
        TAG: /* Index */ 1,
        _0: v
    };
});
var $228f9a1798c51d97$export$932a824d711ed6ad = $79vie.oneOf($228f9a1798c51d97$var$zero, [
    $228f9a1798c51d97$var$pixels,
    $228f9a1798c51d97$var$index
]);
function $228f9a1798c51d97$var$set(key, value) {
    $8wpG4.set(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    }, JSON.stringify($228f9a1798c51d97$export$a91724a679733655(value)));
}
function $228f9a1798c51d97$var$$$delete(key) {
    $8wpG4.$$delete(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    });
}
function $228f9a1798c51d97$var$get(key) {
    return $2whNH.mapWithDefault($8wpG4.get(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    }), /* Zero */ 0, function(position) {
        var result = $79vie.decodeValue(JSON.parse(position), $228f9a1798c51d97$export$932a824d711ed6ad);
        if (result.TAG === /* Ok */ 0) return result._0;
        else return /* Zero */ 0;
    });
}
var $228f9a1798c51d97$export$791f6fca0d60efd9 = {
    set: $228f9a1798c51d97$var$set,
    $$delete: $228f9a1798c51d97$var$$$delete,
    get: $228f9a1798c51d97$var$get
};
var $228f9a1798c51d97$export$f3a17d4d921911b3 = {};
var $228f9a1798c51d97$export$d4351b0ee1c8c8c6 = {
    contents: undefined
};
var $228f9a1798c51d97$export$1f6d3e4fc8cedc8e = {
    contents: {}
};
function $228f9a1798c51d97$export$6bbf62f168c1dddc($$location, id, position) {
    var bucketKey = $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($$location));
    var bucket = $d3YYW.get($228f9a1798c51d97$export$f3a17d4d921911b3, bucketKey);
    $228f9a1798c51d97$var$set(id, position);
    if (bucket !== undefined) $loT9g.valFromOption(bucket)[id] = position;
    else $228f9a1798c51d97$export$f3a17d4d921911b3[bucketKey] = $d3YYW.fromArray([
        [
            id,
            position
        ]
    ]);
}
function $228f9a1798c51d97$export$1dfa5e58b4233c3(paddingOpt, id, center) {
    var padding = paddingOpt !== undefined ? paddingOpt : 0;
    $228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents[id] = {
        center: center,
        padding: padding
    };
}
function $228f9a1798c51d97$export$16e7fafba7e176d(idToDelete) {
    $228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents = $d3YYW.fromArray($i7mYY.keepMap($d3YYW.entries($228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents), function(param) {
        var id = param[0];
        if (id !== idToDelete) return [
            id,
            param[1]
        ];
    }));
}
function $228f9a1798c51d97$export$684cfbe7f928b61e(param) {
    return $58Tj9.stableSortBy($d3YYW.values($228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents), function(a, b) {
        if (a.center > b.center) return 1;
        else if (a.center < b.center) return -1;
        else return 0;
    });
}
function $228f9a1798c51d97$export$6e32c7a2bca8fb40(namespace, id, target) {
    $228f9a1798c51d97$export$6bbf62f168c1dddc($kJhYp.getStatesByNamespace(namespace).current, id, target);
}
function $228f9a1798c51d97$export$69a851a551f434f5(currentScroll, targetScroll) {
    var allPoints = $228f9a1798c51d97$export$684cfbe7f928b61e(undefined);
    return $i7mYY.reduce(allPoints, targetScroll, function(prev, curr) {
        if ((curr.center - curr.padding | 0) <= currentScroll && (curr.center + curr.padding | 0) >= currentScroll) return currentScroll;
        else if (curr.center <= currentScroll) return curr.center;
        else return prev;
    });
}
function $228f9a1798c51d97$export$a2324b57a6a5ec84(dref) {
    $2whNH.map($loT9g.nullable_to_opt(dref.current), function(el) {
        $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents = {
            element: el,
            boundingClientRect: el.getBoundingClientRect()
        };
    });
}
function $228f9a1798c51d97$export$14e0addec6650b88(param) {
    $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents = undefined;
}
function $228f9a1798c51d97$export$ff41c598de81c14a(namespace, localStorage, id) {
    var bucketKey = $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    var fromBucket = $2whNH.flatMap($d3YYW.get($228f9a1798c51d97$export$f3a17d4d921911b3, bucketKey), function(bucket) {
        return $d3YYW.get(bucket, id);
    });
    if (fromBucket !== undefined) return fromBucket;
    if (!localStorage) return /* Zero */ 0;
    var fromLocalStorage = $228f9a1798c51d97$var$get(id);
    $228f9a1798c51d97$var$$$delete(id);
    return fromLocalStorage;
}
var $228f9a1798c51d97$export$398994a7cd250b7e = {
    contents: false
};
function $228f9a1798c51d97$export$aded8d3ce7fe43e1(bool) {
    $228f9a1798c51d97$export$398994a7cd250b7e.contents = bool;
}
function $228f9a1798c51d97$export$51e57029e6716073(param) {
    return $228f9a1798c51d97$export$398994a7cd250b7e.contents;
}
function $228f9a1798c51d97$export$c4ffdfe23dd48040(id) {
    var timeoutRef = $g85JO.useRef(undefined);
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var getInitialResult = function getInitialResult(localStorage) {
        return {
            position: $2whNH.getWithDefault($2whNH.map(id, function(param) {
                return $228f9a1798c51d97$export$ff41c598de81c14a(namespace, localStorage, param);
            }), /* Zero */ 0),
            lock: undefined
        };
    };
    var getCurrentKey = function getCurrentKey(param) {
        return $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    };
    var key = $g85JO.useRef(getCurrentKey(undefined));
    $g85JO.useEffect(function() {
        return function(param) {
            $2whNH.forEach(timeoutRef.current, function(prim) {
                clearTimeout(prim);
            });
        };
    }, []);
    var match$1 = $g85JO.useState(function() {
        return getInitialResult(false);
    });
    var setResult = match$1[1];
    var setResult$1 = function setResult$1(fn) {
        $228f9a1798c51d97$export$398994a7cd250b7e.contents = true;
        $iv6Yc._1(setResult, fn);
        timeoutRef.current = $loT9g.some(setTimeout(function(param) {
            $228f9a1798c51d97$export$398994a7cd250b7e.contents = false;
        }, 100));
    };
    $25dxq.useBrowserNavigation(function(navigationType) {
        if (navigationType !== 1) return $2whNH.forEach(id, $228f9a1798c51d97$var$$$delete);
        var nextResult = getInitialResult(true);
        var match = nextResult.position;
        var nextResultValue = typeof match === "number" ? 0 : match._0;
        setResult$1(function(previousResult) {
            var match = previousResult.position;
            if (typeof match === "number" || match._0 < nextResultValue) return nextResult;
            else return previousResult;
        });
    }, []);
    $g85JO.useEffect(function() {
        setResult$1(function(param) {
            return getInitialResult(false);
        });
    }, [
        id
    ]);
    var update = function update(param) {
        if (id === undefined) return;
        var nextKey = getCurrentKey(undefined);
        if (key.current !== nextKey) {
            setResult$1(function(param) {
                return {
                    position: $228f9a1798c51d97$export$ff41c598de81c14a(namespace, false, id),
                    lock: $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents
                };
            });
            key.current = nextKey;
            return;
        }
    };
    $g85JO.useEffect(function() {
        $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.concat($kJhYp.getStatesByNamespace(namespace).localCallbacks, [
            update
        ]));
        return function(param) {
            $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.keep($kJhYp.getStatesByNamespace(namespace).localCallbacks, function(fn) {
                return fn !== update;
            }));
        };
    }, []);
    return match$1[0];
}
 /*  Not a pure module */ 
});
parcelRegister("8wpG4", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $63453ae6f4ab9cfc$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "$$delete", function () { return $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $63453ae6f4ab9cfc$export$a47fb462a08de82f(key) {
    if (typeof key === "object") {
        var variant = key.NAME;
        if (variant === "optimizeVariant") return "mkr_variant__" + key.VAL + "";
        if (variant === "clientId") return "mkr_client_id__" + key.VAL + "";
    } else {
        if (key === "legacyClientId") return "mkr_client_id";
        if (key === "optimizePreviousEvents") return "mkr_experience_impression";
    }
    var tmp;
    if (typeof key === "object") {
        var variant$1 = key.NAME;
        tmp = variant$1 === "optimizeVariant" ? "optimizeVariant" : variant$1 === "scrollRestoration" ? "scroll-" + key.VAL : variant$1 === "history" ? "history" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "clientId" ? "clientId" : variant$1 === "favorites" ? "favorites" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "selectedMarket" ? "selectedMarket-" + key.VAL : "cart-" + key.VAL;
    } else tmp = key === "debuggerAllowed" ? "debuggerAllowed" : key === "navMenuConfig" ? "navMenuConfig" : key === "legacyClientId" ? "clientId" : key === "gridColumns" ? "gridColumns" : key === "optimizePreviousEvents" ? "optimizePreviousEvents" : "intro";
    return "smartnav__v" + String(2) + "__" + tmp;
}
function $63453ae6f4ab9cfc$export$3988ae62b71be9a3(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            return $2whNH.flatMap($loT9g.null_to_opt($2whNH.getWithDefault(storage, localStorage).getItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key))), function(value) {
                if (value === "") return;
                else return value;
            });
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be(_storage, key, value) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).setItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key), value);
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).removeItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key));
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
var $63453ae6f4ab9cfc$export$83d89fbfd8236492 = 2;
 /* No side effect */ 
});

parcelRegister("25dxq", function(module, exports) {

$parcel$export(module.exports, "useBrowserNavigation", function () { return $18468cc594e5b21b$export$e8c1c060dda75c72; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2Mb3w = parcelRequire("2Mb3w");

var $052u6 = parcelRequire("052u6");
function $18468cc594e5b21b$var$useSafariHack(enabledOpt, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : false;
    $052u6.LegacyNavigationTiming.useLegacyNavigationTiming(enabled, function(param) {
        $iv6Yc._1(callback, param._type);
    }, dependencies);
}
var $18468cc594e5b21b$export$e02aa0e39cbdc151 = {
    useSafariHack: $18468cc594e5b21b$var$useSafariHack
};
function $18468cc594e5b21b$export$e8c1c060dda75c72(callback, dependencies) {
    var isSafari = $2Mb3w.getBrowser(undefined) === /* Safari */ 1;
    $18468cc594e5b21b$var$useSafariHack(isSafari, callback, dependencies);
    $052u6.usePerformanceObserver1(!isSafari, true, /* Navigation */ 0, function(param) {
        $iv6Yc._1(callback, param._type);
    }, dependencies);
}
 /* PerformanceObserver-Showside Not a pure module */ 
});
parcelRegister("052u6", function(module, exports) {

$parcel$export(module.exports, "LegacyNavigationTiming", function () { return $00f26519795813cb$export$127e32ccb8a6e066; });
$parcel$export(module.exports, "usePerformanceObserver1", function () { return $00f26519795813cb$export$d2dfc13adeb0ed2d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");
function $00f26519795813cb$export$48c17662a6902497(param) {
    return $2whNH.isSome(window.PerformanceObserver);
}
function $00f26519795813cb$export$e815e306a6ff66ed(entryType) {
    return "navigation";
}
function $00f26519795813cb$export$2fe53163c7bc4eaf(ext_type) {
    if (ext_type === "back_forward") return /* BackForward */ 1;
    else if (ext_type === "navigate") return /* Navigate */ 0;
    else return /* Reload */ 2;
}
function $00f26519795813cb$export$8ceb1d4b31259502(ext_entry) {
    return {
        _type: $00f26519795813cb$export$2fe53163c7bc4eaf(ext_entry.type)
    };
}
function $00f26519795813cb$export$d3d061a08d0fe848(enabled, options, callback, dependencies) {
    var supported = $2whNH.isSome(window.PerformanceObserver);
    $g85JO.useEffect(function() {
        if (!(enabled && supported)) return;
        var observer = new PerformanceObserver(function(entries) {
            $iv6Yc._1(callback, $i7mYY.map(entries.getEntries(), $00f26519795813cb$export$8ceb1d4b31259502));
        });
        try {
            observer.observe(options);
            var observer$1 = observer;
            return function(param) {
                $2whNH.forEach(observer$1, function(obs) {
                    obs.disconnect();
                });
            };
        } catch (e) {
            return;
        }
    }, dependencies);
}
function $00f26519795813cb$var$useLegacyNavigationTiming(enabledOpt, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var callback$1 = function callback$1(e) {
        $2whNH.forEach($2whNH.map($i7mYY.get(window.performance.getEntriesByType("navigation"), 0), function(entry) {
            return {
                _type: $2whNH.getWithDefault(e.persisted, false) ? /* BackForward */ 1 : ({
                    _type: $00f26519795813cb$export$2fe53163c7bc4eaf(entry.type)
                })._type
            };
        }), callback);
    };
    $g85JO.useEffect(function() {
        if (enabled) {
            window.addEventListener("pageshow", callback$1);
            return function(param) {
                window.removeEventListener("pageshow", callback$1);
            };
        }
    }, dependencies);
}
var $00f26519795813cb$export$127e32ccb8a6e066 = {
    useLegacyNavigationTiming: $00f26519795813cb$var$useLegacyNavigationTiming
};
function $00f26519795813cb$export$d2dfc13adeb0ed2d(enabledOpt, bufferedOpt, entryType, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var buffered = bufferedOpt !== undefined ? bufferedOpt : false;
    var options_type = "navigation";
    var options = {
        entryTypes: undefined,
        type: options_type,
        buffered: buffered
    };
    $00f26519795813cb$export$d3d061a08d0fe848(enabled, options, function(entries) {
        $2whNH.forEach($i7mYY.get(entries, 0), callback);
    }, dependencies);
}
 /* react Not a pure module */ 
});



})();
//# sourceMappingURL=LauncherApp.bs.c3585643.js.map
